import t from"react";import{mdiRefresh as e}from"@mdi/js";import{MdIcon as r}from"./MdIcon.js";const o=({id:o="refresh",title:i="Refresh",...m})=>t.createElement(r,{id:o,title:i,path:e,...m});export{o as RefreshIcon};
